import { APP_BASE_HREF } from '@angular/common';
import { InjectionToken, Injector, PLATFORM_ID } from '@angular/core';

export const PROTOCOL = new InjectionToken('ProtocolToken');

export function protocolFactory(): any {
  return window.location.protocol.split(':')[0];
}

export const PROTOCOL_PROVIDER = {
  provide: PROTOCOL,
  useFactory: protocolFactory,
  deps: [PLATFORM_ID, Injector],
};
export const APP_BASE_HREF_PROVIDER = {
  provide: APP_BASE_HREF,
  useValue: '/',
  deps: [PLATFORM_ID, Injector],
};
